import React from 'react';
import classNames from 'classnames';

import InputAdornment from "@material-ui/core/InputAdornment";
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { FaInfoCircle } from 'react-icons/fa';
import ReactTooltip from 'react-tooltip';

const formControlStyle = {minWidth: '80px', maxWidth: '10%'}
const seperationLineStyle = {borderTop: '2px solid black', minWidth: '80px', maxWidth: '1364px'}


const ModelingDomain = props => {

    return (
    <div className="form-input-container">
        <div>
            <b>{props.title}</b>
            <br></br>
            {props.tooltip}
        </div>

        <div>
            <Button
                className={classNames(props.classes.margin, props.classes.textField)}
                component="label"
                variant="outlined"
                color="default"
            > 
                Upload 'namelist.wps' File
                <input 
                    type="file"
                    accept="text/.wps"
                    style={{ display: 'none'}}
                    onChange={(e) => props.readDomainFile(e)}
                />
            </Button>
        </div>

        <div >
            {props.domain_config.modeling_domain.values.map(row => (
                    <FormControl key={row.label} style={formControlStyle} className={classNames(props.classes.margin, props.classes.formControl)}>
                        <InputLabel shrink>{row.label}</InputLabel>
                        <Input
                            // required={props.required === 'false' ? true : false}
                            id={row.label}
                            value={props.domain[row.value]}
                            onChange={props.handleInputChange}
                            name={row.value}
                            type={row.type}
                            inputProps={{min:row.min, max:row.max, step:row.step, maxLength:row.maxLength}}
                            placeholder={row.placeholder}
                            endAdornment={<InputAdornment position="end">{row.unit}</InputAdornment>}
                        />
                    </FormControl>
            ))}
        </div>

    </div>
)}
export default ModelingDomain;
